import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class SubmittingAnInvestorLetterOfIntentForm extends AppForm {
  constructor() {
    super({
      investmentLocation: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      investmentPurpose: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      investmentSchedule: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      investmentInfrastructureRequirements: new FormControl(null, [Validators.required, Validators.maxLength(255)])
    });
  }
}
